import { render, staticRenderFns } from "./EventRegistrationLegacyId.vue?vue&type=template&id=73edd085"
import script from "./EventRegistrationLegacyId.vue?vue&type=script&lang=js"
export * from "./EventRegistrationLegacyId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports